import classnames from 'classnames';
import React, { useMemo } from 'react';

import styles from './MessageBlock.module.scss';

interface MessageBlockProps {
  messages?: string | string[];
  lineBreakBetweenMsgs?: boolean;
  doubleLineBreakBetweenMsgs?: boolean;
  textAlign?: 'left' | 'center' | 'right';
  isBold?: boolean;
}

export const MessageBlock = ({
  messages,
  lineBreakBetweenMsgs,
  doubleLineBreakBetweenMsgs,
  textAlign = 'center',
  isBold,
}: MessageBlockProps) => {
  const maxMessageLimit = 200;

  const messageArray = useMemo(() => {
    if (!messages) return [];
    if (Array.isArray(messages)) return messages;
    return [messages];
  }, [messages]);

  const containerStyles = classnames(styles.container, {
    [styles.message]: messages,
    [styles[textAlign || '']]: textAlign,
    [styles.bold]: isBold,
  });

  if (!messageArray.length) return null;

  return (
    <div>
      {messageArray.map((message, index) => {
        return (
          <React.Fragment key={index}>
            {/* <div className={`${styles.message} ${textAlign}`}> */}
            <div className={containerStyles}>
              {message.slice(0, maxMessageLimit)}
              {message.length > maxMessageLimit ? '...' : ''}
            </div>
            {lineBreakBetweenMsgs && <div className={styles.lineBreak}></div>}
            {doubleLineBreakBetweenMsgs && (
              <>
                <div className={styles.lineBreak}></div>
                <div className={styles.lineBreak}></div>
              </>
            )}
          </React.Fragment>
        );
      })}

      <div
        className={
          lineBreakBetweenMsgs || doubleLineBreakBetweenMsgs ? styles.spaceReducer : styles.spacer
        }></div>
    </div>
  );
};
